import React from 'react'
import { connect } from 'react-redux'
import { Divider } from 'semantic-ui-react'
// Local
import { EncounterDetail } from '../../authenticated/types'
import {
  ENCOUNTER,
  shouldRenderReskin2025
} from '../../../constant'
import * as lockUtils from '../../common/lockUtils'
import { isCdiQaManager } from '../../common/roleUtils'
import EncounterAppointment from '../common/encounterAppointment'
import EncounterCancelButton from '../common/EncounterCancelButton'
import EncounterCdiQa from '../common/encounterCdiQa'
import EncounterIgnoreButton from '../common/encounterIgnoreButton'
import EncounterPatient from '../common/encounterPatient'
import EncounterPractitioner from '../common/encounterPractitioner'
import EncounterProfile from '../common/encounterProfile'
import EncounterReason from '../common/encounterReason'
import EncounterSource from '../common/encounterSource'
import EncounterStatus from '../common/encounterStatus'
import NavSpacer from '../common/navSpacer'
import PatientRegion from '../common/patientRegion'
import PatientRuleFilters from '../common/patientRuleFilters'
import PatientRuleHccVersion from '../common/patientRuleHccVersion'
import VbcProgram from '../common/vbcProgram'
import If from '../../common/if'
import { Patient } from '../../patient/patient'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type PropsFromRedux = ReturnType<typeof mapStateToProps>

type Props = PropsFromRedux & {
  encounterDetail: EncounterDetail
  onAction: (x: keyof typeof ENCOUNTER.ACTION) => void
}

/**
 * Provides a component that displays the left column of the CDI encounter
 * detail
 * @param encounterDetail Encounter detail entity
 * @param onAction Callback for action. Arguments: action
 */
function CdiEncounterLeft(props: Props) {
  const {
    currentUser,
    encounterDetail,
    onAction
  } = props
  const encounterDetailReview = encounterDetail.encounter && encounterDetail.encounter.review
  const encounterDetailPatient = encounterDetail.encounter && encounterDetail.encounter.patient
  const encounterDetailLock = encounterDetail.encounter && encounterDetail.encounter.lock
  const isEditMode = lockUtils.canEdit(
    encounterDetailLock,
    currentUser
  )

  const className = shouldRenderReskin2025
    ? 'cdi-encounter-left-column reskin'
    : 'cdi-encounter-left-column'

  const onClickCancel = (encounterStatus: string): void => {
    if (encounterStatus === ENCOUNTER.STATUS.CANCELLED) {
      onAction(ENCOUNTER.ACTION.STATUS_TOGGLE_CANCELLED)
    }
    if (encounterStatus === ENCOUNTER.STATUS.PLANNED) {
      onAction(ENCOUNTER.ACTION.STATUS_TOGGLE_PLANNED)
    }
  }

  const onClickIgnore = (
    encounterStatus: keyof typeof ENCOUNTER.STATUS
  ): void => {
    if (encounterStatus === ENCOUNTER.STATUS.IGNORED) {
      onAction(ENCOUNTER.ACTION.STATUS_TOGGLE_IGNORED)
    }
    if (encounterStatus === ENCOUNTER.STATUS.PLANNED) {
      onAction(ENCOUNTER.ACTION.STATUS_TOGGLE_PLANNED)
    }
  }
  return (
    <div className={ className }>
      <If isTrue={ !shouldRenderReskin2025 }>
        <Divider className="green-border" />
      </If>
      <EncounterCdiQa
        mode="left"
        review={ encounterDetailReview }
      />
      <EncounterProfile
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      <If isTrue={ shouldRenderReskin2025 }>
        <div className="profile-divider" />
      </If>
      <EncounterPatient
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      <PatientRegion
        mode="left"
        patient={ encounterDetailPatient }
      />
      { /* TODO: THIS IS POSSIBLY A DEFECT!!!!!!! */ }
      <EncounterSource
        mode="left"
        encounter={ encounterDetail.encounter as Patient }
      />
      <EncounterReason
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      <EncounterAppointment
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      { encounterDetail.encounter && (
        <EncounterStatus
          mode="left"
          encounter={ encounterDetail.encounter }
        />
      ) }
      <EncounterPractitioner
        mode="left"
        encounter={ encounterDetail.encounter }
      />
      <VbcProgram
        mode="left"
        patient={ encounterDetailPatient }
      />
      <PatientRuleFilters
        mode="left"
        patient={ encounterDetailPatient }
        currentUser={ currentUser }
      />
      <PatientRuleHccVersion
        mode="left"
        patient={ encounterDetailPatient }
      />
      <If isTrue={ isEditMode }>
        <EncounterCancelButton
          mode="left"
          encounter={ encounterDetail.encounter }
          onClick={ onClickCancel }
        />
      </If>
      <If isTrue={ isEditMode && isCdiQaManager(currentUser.roles) }>
        <div>
          <NavSpacer
            height="64px"
            mode="segment"
          />
          <EncounterIgnoreButton
            mode="left"
            encounter={ encounterDetail.encounter }
            onClick={ onClickIgnore }
          />
        </div>
      </If>
    </div>
  )
}

export default connect(mapStateToProps)(CdiEncounterLeft)
